import React, { useContext } from "react";
import styled, { css } from "styled-components";
import MessageField from "views/components/messagelist/MessageField";
import { MessageDetailsDefinitionList } from "components/common";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
export const MessageDetailsDL = styled(MessageDetailsDefinitionList)(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};

    dd {
      &:not(:last-child) {
        border-bottom: 1px solid ${theme.colors.table.row.divider};
      }
    }
  `
);
const MessageFieldsViewModeList = ({ fields, isFavorite = false }) => {
  const { message } = useContext(MessageFavoriteFieldsContext);
  if (!fields.length) return null;
  return /* @__PURE__ */ React.createElement("div", { "data-testid": `${isFavorite ? "favorite" : "rest"}-fields-list` }, /* @__PURE__ */ React.createElement(MessageDetailsDL, { className: "message-details-fields" }, fields.map(({ field, value, type }) => /* @__PURE__ */ React.createElement(MessageField, { key: field, fieldName: field, fieldType: type, value, message }))));
};
export default MessageFieldsViewModeList;
